import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import constants from '../../../../core/constants';
import ActivitiesDataRepository from '../../../../data/repositories/ActivitiesDataRepository';
import ActivitiesRepository from '../../../repositories/ActivitiesRepository';

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_ACTIVITIES_REQUEST });
    // consultar horario
    const activitiesRepository: ActivitiesRepository =
      new ActivitiesDataRepository();
    const activitiesResponse = yield call(activitiesRepository.getActivities);
    if (!activitiesResponse) {
      yield put({
        type: Types.GET_ACTIVITIES_FAILURE,
        error: 'Ocurrió un error'
      });
      return;
    }
    const meetings = activitiesResponse?.map((a: any) => {
      const arrayDate = a.date.split('-');
      const stdate = `${arrayDate[0]}/${arrayDate[1]}/${arrayDate[2]}`;
      return {
        start: new Date(`${stdate} ${a.startTime}`).getTime(),
        end: new Date(`${stdate} ${a.endTime}`).getTime(),
        date: new Date(`${stdate}`).getTime() + constants.MIL_PERU,
        professor: '',
        name: a.service.name,
        reservationCode: a.code,
        idZoom: a?.link || '',
        type: 'A',
        eventId: a?.idEvent,
        modality: a?.modality?.code,
        isReprog: a?.isRescheduled || false
      };
    });

    const data = {
      subscriptions: meetings,
      eventTypes: activitiesResponse?.eventTypes
    };
    yield put({ type: Types.GET_ACTIVITIES_SUCCESS, data });
  } catch (error) {
    yield put({
      type: Types.GET_ACTIVITIES_FAILURE,
      error: 'Ocurrió un error'
    });
    throw error;
  }
}
